module.exports = __webpack_public_path__ + "static/img/r-1-5.789800e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/r-1-5.png
// module id = qjog
// module chunks = 0